export const formatters = {
  currency: (value: number): string => {
    if (isNaN(value)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  },

  number: (value: number): string => {
    if (isNaN(value)) return '';
    return new Intl.NumberFormat('en-US').format(value);
  },

  percentage: (value: number): string => {
    if (isNaN(value)) return '';
    return `${Math.round(value)}%`;
  },

  string: (value: string): string => value,

  getCurrencyColorClass: (value: number): string =>
    value >= 0 ? 'generic-metrics-table-cell--positive' : 'generic-metrics-table-cell--negative',
};
